import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import { fetchStaffGrade } from "../../../../features/dropdown/dropdownSlice";

const { TextArea } = Input;

const AddPositionModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { staffPosition, staffGradeData, loading } = useSelector(
    (state) => state.dropdown
  );
  const { saving } = useSelector((state) => state.save);

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if (!formData?.spSgId) {
      toast.error("Please select grade");
      return;
    }
    const objPos = staffPosition?.find((item) => item?.spId === formData?.reportingPositionId) 
    const res = await dispatch(
      save({
        spId: prodd?.spId ? prodd?.spId : null,
        spSgId: formData?.spSgId,
        spPositioncode: formData?.spPositioncode,
        spPositionname: formData?.spPositionname,
        jobObjective: formData?.jobObjective,
        reportingPositionId: formData?.reportingPositionId,
        reportingPositionName: objPos?.spPositionname,

        url: "hr/saveStaffPosition.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchStaffGradeData() {
    dispatch(fetchStaffGrade());
  }

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit position ${prodd?.spPositionname}`
            : "Add position detail ds"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            className=""
            label={<span>Grade</span>}
            rules={[
              {
                required: true,
                message: "Please select grade",
              },
            ]}
          >
            <Select
              name="spSgId"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                staffGradeData?.length > 0 &&
                staffGradeData?.map((item) => ({
                  value: item?.sgId,
                  label: item?.sgGradename,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "spSgId");
              }}
              value={formData?.sgGradename}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchStaffGradeData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            label="Position Code"
            rules={[
              {
                required: true,
                message: "Enter Position Code",
              },
            ]}
          >
            <Input
              required
              name="spPositioncode"
              onChange={onChange}
              value={formData?.spPositioncode}
              className="input"
            />
          </Form.Item>
          <Form.Item
            label="Position Name"
            rules={[
              {
                required: true,
                message: "Enter Position name",
              },
            ]}
          >
            <Input
              required
              name="spPositionname"
              onChange={onChange}
              value={formData?.spPositionname}
              className="input"
            />
          </Form.Item>

          <Form.Item
            className=""
            label={<span>Reporting Position</span>}
            rules={[
              {
                required: false,
                message: "Please select reporting position",
              },
            ]}
          >
            <Select
              name="reportingPositionId"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                staffPosition?.length > 0 &&
                staffPosition?.map((item) => ({
                  value: item?.spId,
                  label: item?.spPositionname,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "reportingPositionId");
              }}
              value={formData?.reportingPositionId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            label="Job Objective"
            rules={[
              {
                required: true,
                message: "Enter job objective",
              },
            ]}
          >
            <TextArea
              required
              name="jobObjective"
              onChange={onChange}
              value={formData?.jobObjective}
              rows={4}
              className="input-textarea"
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddPositionModal;
